<template>
    <span class="k-num" :class="className">
        <span class="k-num__num">{{numText}}</span><span class="k-num__unit">{{numUnit}}</span>
    </span>
</template>

<script>
    import {isString, isNumeric, isUndefined} from '../../utils/base'
    import {fixNumber} from '../../utils/formatter'
    
    export default {
        name: 'k-num',
        props: ['value', 'sign', 'skin', 'unit', 'fixed'],
        computed: {
            className() {
                const {skin, value, sign} = this
                if(isNumeric(skin)) {
                    return skin < 0 ? 'down' : skin > 0 ? 'up' : 'flat'
                } else if(isString(skin) && skin) {
                    return skin
                } else if(sign === true) {
                    return value < 0 ? 'down' : value > 0 ? 'up' : 'flat'
                }
                return ''
            },
            numText() {
                let value = Math.abs(+this.value)
                value = value >= 100000000 ? value / 100000000 : value >= 10000 ? value / 10000 :  value
                let sign = ''
                if(this.sign === true) {
                    sign = +this.value < 0 ? '-' : '+'
                    //value = Math.abs(value)
                }
                value = fixNumber(value, 10, true)

                let {fixed} = this
                fixed = isUndefined(fixed) ? -2 : fixed
                if(fixed < 0) {// 负数：自动去掉末尾0
                  value = +value.toFixed(-fixed)
                } else if(fixed > 0 || fixed === 0) {
                  value = value.toFixed(fixed)
                }
                return sign + value
            },
            numUnit() {
                const _unit = isString(this.unit)? this.unit : '' // 单位
                const value = Math.abs(this.value)
                const unit = value >= 100000000 ? '亿' :  value >= 10000 ? '万': ''
                return `${unit}${_unit}`
            }
        }
    }

</script>
